import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import JobDetails from 'hb-react/frontoffice/apps/JobsV2/components/JobDetails';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const JobDetailsPage = ({ urls, configPage, topic }) => {
  const { opportunityId } = useParams();
  const breakpoint = useBreakpoint();

  const { data: job, isLoading } = useQuery(['job', opportunityId], () => {
    const url = urls.fetchItem({ opportunityId });

    return axios
      .get(url)
      .then((res) => res.data.request)
      .catch((error) => {
        if (error.response.status === 403) {
          window.location = `/login?redirect_to=${encodeURIComponent(
            window.location.pathname,
          )}`;
        }

        throw error;
      });
  });

  if (isLoading) {
    return null;
  }

  return (
    <Container>
      <Grid width="100%" mx={breakpoint === 's' ? 0 : undefined}>
        <Row>
          <Col width={{ _: 1, l: 10 / 12 }} offset={{ _: 0, l: 1 / 12 }}>
            <Box pb={9} display="block" mt={{ _: 0, m: 7 }}>
              <JobDetails
                configPage={configPage}
                job={job}
                noBorderRadiusOnSmallScreen
                topic={topic}
                urls={urls}
              />
            </Box>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default JobDetailsPage;
